module.exports = __webpack_public_path__ + "static/img/wechat.b1876238.png";